import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { img_size } from "../../utils";
import { FontFamilySwitch, generateImageUrl } from "../../utils/common";
const useStyles = makeStyles((theme) => ({
  img: {
    backgroundColor: "white",
  },
  rootcard: {
    borderRadius: "4px",
    padding: "8px 12px",
    marginTop: "10px",
    //backgroundImage: `url("/images/Mask_Group_47.svg")`,
    cursor: "pointer",
    backgroundRepeat: "no-repeat",
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().semiBold,
    backgroundPositionX: "100%",
  },
  title: {
    color: "white",
    fontFamily: FontFamilySwitch().semiBold,
    fontSize: "0.75rem"
  },
  arrow: {
    fontSize: "0.9375rem",
  },
  notInterestedStyle: {
    textAlign: "center",
    textDecoration: "underline",
    color: "#5078E1",
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
    cursor: "pointer",
    marginTop: "12px"
  },
}));

export const Actioncard = (props) => {
  const { t = () => false } = props
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        onClick={() => {
          props.action(props?.data);
        }}
      >
        <Grid item xs={12}>
          {
            props?.data?.id === 4 ?
              <Typography className={classes.notInterestedStyle}>
                {t("Not Interested")}
              </Typography>

              :
              <Box
                display="flex"
                style={{ backgroundColor: props.data.color }}
                alignItems="center"
                className={classes.rootcard}
              >
                <Box>
                  {
                    props?.data?.icon ? props?.data?.icon:
                    <Avatar className={classes.img}>
                    <img src={generateImageUrl(props.data.img, img_size.small_square)} alt={props.data.title} />
                  </Avatar>
                  }
                  
                </Box>
                <Box flexGrow={1}>
                  <Typography className={classes.title}>
                    &nbsp;&nbsp;{props.data.title}
                  </Typography>
                </Box>
                <Box>
                  <Avatar className={classes.img} sx={{ width: 30, height: 30 }}>
                    <ArrowForwardIosIcon
                      className={classes.arrow}
                      style={{ color: props.data.color }}
                    />
                  </Avatar>
                </Box>
              </Box>
          }

        </Grid>
      </Grid>
    </div>
  );
};
